<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'riskSummary.cardTitle' | t }}</div>
    @if (summaryModel) {
        <div class="detail-page-card-actions">
            @if (summaryModel.CanOpenParent) {
                <button class="btn btn-raised" data-uiid="risk-moi-open-risk-button" (click)="openRisk()">
                    <i class="fas fa-external-link-alt"></i>
                    <span>{{ 'riskSummary.openRiskBtn' | t }}</span>
                </button>
            }
        </div>
    }

    <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
        @if (summaryModel) {
            <div>
                <div class="row">
                    <div class="col-3">
                        <div class="form-group">
                            <label>{{ 'riskSummary.identifierLabel' | t }}</label>
                            <input
                                data-uiid="risk-moi-identifier"
                                type="text"
                                class="form-control form-control-sm"
                                disabled
                                [value]="summaryModel.Identifier"
                                inputTooltip
                            />
                        </div>
                    </div>
                    <div class="col-9">
                        <div class="form-group">
                            <label>{{ 'riskSummary.riskNameLabel' | t }}</label>
                            <input
                                data-uiid="risk-moi-name"
                                type="text"
                                class="form-control form-control-sm"
                                disabled
                                [value]="summaryModel.Name"
                                inputTooltip
                            />
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>{{ 'riskSummary.descriptionLabel' | t }}</label>
                    <textarea
                        data-uiid="risk-moi-description"
                        class="form-control form-control-sm"
                        disabled
                        [value]="summaryModel.Description"
                        inputTooltip
                    ></textarea>
                </div>
            </div>
        } @else {
            <div class="fancy-loader submodule my-4"></div>
        }
    </div>
</div>
